Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.NumericFilterView extends Backbone.View
  template: JST['backbone/templates/monitoring/filters/numeric_filter']
  className: 'filter time collapsed'
  fieldName: 'numeric'

  events:
    'click #apply': '_apply'

  initialize: ({searchQuery, title}) ->
    @searchQuery = searchQuery
    @title = title

  destroy: ->
    @remove()
    false

  render: ->
    @$el.html(@template(title: @title))
    @

  _apply: (event) =>
    min = @$el.find('#min').val()
    max = @$el.find('#max').val()
    return unless @_isValid(min, max)
    @searchQuery.resetField("min_#{@fieldName}")
    @searchQuery.resetField("max_#{@fieldName}")
    @searchQuery.set("min_#{@fieldName}", min) if min
    @searchQuery.set("max_#{@fieldName}", max) if max
    @_triggerQueryChanged()

  _isValid: (min, max) ->
    return swal({
      html: true,
      title: I18n.t('monitoring.alerts.number_range'),
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: false,
      confirmButtonClass: 'btn-primary customer-button',
      confirmButtonText: I18n.t('ok')
    }, ->) if min > max
    true

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
